// extracted by mini-css-extract-plugin
module.exports = {"grid-column":"_column_grid-column__2Ph-u"};